import Axios from 'axios'
import React, { Component } from 'react'
import Button from '../../../Components/Button'
import Spinner from '../../../Components/Spinner'
import { Table, Tbody, Td, Th, Thead } from '../../../Components/Table'
import './BDGrid.scss'

export default class BDGrid extends Component {
    constructor(props) {
        super(props)

        this.state = {
            pageFields: [],
            gridColumns: [],
            data: [],
            currentPageNumber: 1,
            prevPageNumber: null,
            nextPageNumber: null,
            loading: false,
            dataFetched: false,
            allSelected: false,
            pageSize: 10,
            count: 0
        }
    }

    componentDidMount() {
        this.setState({
            pageFields: this.props.pageFields
        }, () => {
            this.setGridColumns()
        })

        this.getData().then(res => { this.setData(res) })
    }

    setData = (res) => {
        if (res) {
            let data = res.listData || []
            let currentPageNumber = res.currentPageNumber || 1
            let prevPageNumber = res.prevPageNumber
            let nextPageNumber = res.nextPageNumber
            let pageSize = res.pageSize
            let count = res.count
            this.setState({
                data,
                currentPageNumber,
                prevPageNumber,
                nextPageNumber,
                pageSize,
                count,
                loading: false
            })
        } else {
            this.setState({
                loading: false
            })
        }
    }

    setGridColumns = () => {
        const { pageFields } = this.state
        const gridColumns = pageFields.filter(x => x.inGrid === true).sort((a, b) => { return ((a.gridDisplayOrder || 0) - (b.gridDisplayOrder || 0)) })
        this.setState({
            gridColumns: gridColumns
        })
    }

    getData = async (pageNumber) => {
        const url = `${this.props.apiUrl}/getall?pageNumber=${pageNumber ? pageNumber : 1}`
        return Axios.get(url).then(res => {
            if (!res.data.error) {
                return res.data.data;
            } else {
                alert(res.data.message)
                return null;
            }
        }).catch(err => {
            console.error(err)
            this.setState({
                loading: false
            })
            return null;
        })
    }

    markRowSelected = (e, id) => {
        let { data, allSelected } = this.state
        data.find(x => x._id === id).rowSelected = e.target.checked

        data.filter(x => x.rowSelected === false).length ? allSelected = false : allSelected = true

        this.setState({
            data, allSelected
        })
    }

    toggleSelectionAllRows = (e) => {
        let { allSelected, data } = this.state
        allSelected = e.target.checked

        if (allSelected) {
            data.forEach(item => { item.rowSelected = true })
        } else {
            data.forEach(item => { item.rowSelected = false })
        }

        this.setState({ data, allSelected })
    }

    deleteRecord = (id) => {
        let accepted = false
        accepted = window.confirm('Are you sure you want to delete this record?')
        if (accepted) {
            this.props.onClickDelete(id).then(res => {
                if (res) {
                    this.getData(this.state.currentPageNumber).then(res => { this.setData(res) })
                }
            })
        }
    }

    Pagination = (props) => {
        let { count, pageSize, currentPageNumber, prevPageNumber, nextPageNumber } = props

        const makePrevButton = prevPageNumber ? true : false;
        const makeNextButton = nextPageNumber ? true : false;

        return (
            <div className="bd-pagination">
                <div className="btns-container">
                    {
                        makePrevButton ? (
                            <Button className='pagination-btn' variant={'primary'} onClick={() => { this.getData(props.prevPageNumber).then(res => { this.setData(res) }) }}>Prev</Button>
                        ) : null
                    }
                    {
                        [...new Array(Math.ceil(count / pageSize))].map((_, idx) => {
                            return (
                                <Button key={idx + 1} className={`pagination-btn ${currentPageNumber === idx + 1 ? 'active' : ''}`} variant={'primary'} onClick={() => { this.getData(idx + 1).then(res => { this.setData(res) }) }}>{idx + 1}</Button>
                            )
                        })
                    }
                    {
                        makeNextButton ? (
                            <Button className='pagination-btn' variant={'primary'} onClick={() => { this.getData(props.nextPageNumber).then(res => { this.setData(res) }) }}>Next</Button>
                        ) : null
                    }
                </div>
            </div>
        )
    }

    render() {
        const { data, loading, allSelected, gridColumns } = this.state

        return (
            <>
                {
                    loading ? (
                        <Spinner />
                    ) : (
                            <>
                                <div className='bd-grid'>
                                    <Table>
                                        <Thead>
                                            <Th className={'checkbox-holder'}>
                                                <input checked={allSelected} onChange={this.toggleSelectionAllRows} type="checkbox" />
                                            </Th>
                                            <Th titleSameAsContent>Actions</Th>
                                            {
                                                gridColumns.map((item, index) => {
                                                    return (
                                                        <Th titleSameAsContent key={index}>{item.label || ''}</Th>
                                                    )
                                                })
                                            }
                                        </Thead>
                                        <Tbody>
                                            {
                                                data.map((item, idx) => {
                                                    return (
                                                        <tr key={idx} className={`${idx % 2 === 0 ? 'tr--dark' : 'tr--light'}`}>
                                                            <Td className={'checkbox-holder'}>
                                                                <input defaultChecked={false} checked={item.rowSelected} onChange={e => { this.markRowSelected(e, item._id) }} type="checkbox" name="" id={item._id} />
                                                            </Td>
                                                            <Td className={'actions'}>
                                                                <Button className={'actions__btn actions__btn--edit'}>E</Button>
                                                                <Button onClick={() => { this.deleteRecord(item._id) }} className={'actions__btn actions__btn--delete'}>D</Button>
                                                            </Td>
                                                            {
                                                                gridColumns.map((col, idx) => {
                                                                    return (
                                                                        <Td key={idx} titleSameAsContent>{item[col.id]}</Td>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </Tbody>
                                    </Table>
                                </div>
                                <this.Pagination
                                    currentPageNumber={this.state.currentPageNumber}
                                    prevPageNumber={this.state.prevPageNumber}
                                    nextPageNumber={this.state.nextPageNumber}
                                    pageSize={this.state.pageSize}
                                    count={this.state.count}
                                />
                            </>
                        )
                }
            </>
        )
    }
}